// src/pages/AccountPage.js
import { Navigate } from "react-router-dom";
import React from "react";
import useAuthUser from "../components/useAuthUser";
import Dashboard from "../components/Dashboard";

export default function AccountPage({ themeKey, themes }) {
  const user = useAuthUser();
  const theme = themes?.[themeKey] || {
    colors: { background: "#fff", text: "#222" },
    fontFamily: "sans-serif"
  };

  if (user === null) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div
      className="min-h-screen"
      style={{
        background: theme.colors.background,
        color: theme.colors.text,
        fontFamily: theme.fontFamily,
      }}
    >
      <h2 className="text-2xl font-bold my-4 px-4 text-center">
        Welcome, {user.displayName || user.email || "User"}!
      </h2>
      <Dashboard />
    </div>
  );
}
